import {
  WSButton,
  WSFlexBox,
  WSFlexBoxProps,
  WSPill,
  WSPillProps,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import styles from "./FieldView.module.scss";

export type FieldViewProps = WSFlexBoxProps & {
  label: string;
  pill?: WSPillProps;
  value?: React.ReactNode;
  fullWidth?: boolean;
  action?: {
    label: string;
    onClick: () => void;
  };
};

export const FieldView: React.FC<FieldViewProps> = ({
  label,
  value = "-",
  action,
  fullWidth,
  pill,
  ...otherProps
}) => {
  return (
    <WSFlexBox
      direction="column"
      gap="S"
      alignItems="stretch"
      className={styles.fieldView}
      {...otherProps}
    >
      <WSFlexBox.CenterY
        gap="S"
        justify="space-between"
        className={styles.labelWrapper}
      >
        <WSFlexBox.CenterY gap="M">
          <WSText.ParagraphSm color="gray500" singleLine>
            {label}
          </WSText.ParagraphSm>
          {pill && <WSPill {...pill} />}
        </WSFlexBox.CenterY>
        {action && (
          <WSButton.Link size="S" onClick={action.onClick}>
            {action.label}
          </WSButton.Link>
        )}
      </WSFlexBox.CenterY>
      <WSText.ParagraphSm
        as={fullWidth || React.isValidElement(value) ? "div" : undefined}
        color="gray700"
        singleLine={!fullWidth}
      >
        {value}
      </WSText.ParagraphSm>
    </WSFlexBox>
  );
};
